/** Whether `text` contains the search `query`, ignoring case and surrounding spaces; an empty query matches all */
export const matchesSearch = (text: string, query: string) => text.toLowerCase().includes(query.trim().toLowerCase());
